import { toThemeColor } from "../engine/theme";

/**
 * Whether two CSS colours are the same colour, whatever way they are
 * written ("#FF0000", "#ff0000", "red"): a saved style and a palette colour.
 *
 * @param {string} first
 * @param {string} second
 * @returns {boolean}
 */
export const isSameColor = (first, second) => {
  if (!first || !second) return false;
  if (first.toLowerCase() === second.toLowerCase()) return true;

  return toThemeColor(first).rgba.join() === toThemeColor(second).rgba.join();
};
